import { endOfMonth, differenceInDays, startOfMonth, parseISO } from 'date-fns';
import { storeNameList } from '../../Container/utils';
export function findKeyByValue(obj, valueToFind) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === valueToFind) {
      return key;
    }
  }
  return null;
}

export const keysToSum = [
  'accessories',
  'addon',
  'applecare',
  'hardwareupgrade',
  'postpaidtarget',
  'prepaidtarget',
  'smssurvey',
];

export const calculateTarget = (data) => {
  return data?.reduce((acc, item) => {
    keysToSum.forEach((key) => {
      acc[key] = (acc[key] || 0) + parseInt(item[key], 10);
    });
    return acc;
  }, {});
};

export const calculateAdjustedTargetByDates = (dates, targetRow) => {
  const selectedStartDate = parseISO(dates?.startDate);
  const selectedEndDate = parseISO(dates?.endDate);
  const totalDaysInMonth =
    differenceInDays(endOfMonth(selectedStartDate), startOfMonth(selectedStartDate)) + 1;
  const selectedDays = differenceInDays(selectedEndDate, selectedStartDate) + 1;

  if (totalDaysInMonth !== selectedDays) {
    const resultForSelectedDays = {};
    Object.keys(targetRow).forEach((key) => {
      const valueForSelectedDays = (targetRow[key] / totalDaysInMonth) * selectedDays;
      resultForSelectedDays[key] = Math.round(valueForSelectedDays);
    });
    return resultForSelectedDays;
  } else {
    return targetRow;
  }
};
export const filterEventCisData = (list, storeKey, empKey, empValue, storeValue ) => {
  if (!storeValue && !empValue ) {
    return list;
  }
  const emailPrefix = empValue + '@vyadom.com';
  
  const filteredList = [];
  list?.forEach((item) => {
    if (
      (storeValue === '' || item[storeKey] === storeValue) &&
      (empValue === '' || item[empKey] === emailPrefix)
    ) {
      filteredList.push(item);
    }
  });
  return filteredList;
};

export const filterTargetData = (list, storeKey, empKey, empValue, storeValue ) => {
  if (!storeValue && !empValue ) {
    return list;
  }
  const emailPrefix = empValue + '@vyadom.com';
  
  const filteredList = [];
  list?.forEach((item) => {
    if (
      (storeValue === '' || item[storeKey] === storeValue) &&
      (empValue === '' || item[empKey] === emailPrefix)
    ) {
      filteredList.push(item);
    }
  });
  return filteredList;
};

export const filterAccessoryARData = (ARateList, currentfilter ) => {
  let filterARList = ARateList?.All || {        act: 0,
    actWithoutAcc: 0,
    actCount: 0,
    hup: 0,
    actARate: 0,
    hupARate: 0,
    Total_ACT:0};
  if (currentfilter?.length === 2) {
    const emailPrefix = currentfilter[0] + '@vyadom.com';
    if (currentfilter[0] && currentfilter[1] === undefined) {
      filterARList = Object.keys(ARateList?.employeeAR || {}).reduce((acc, empName) => {
        if (empName === emailPrefix) {
          acc = ARateList.employeeAR[emailPrefix];
        }
        return acc;
      }, {
        act: 0,
        actWithoutAcc: 0,
        actCount: 0,
        hup: 0,
        actARate: 0,
        hupARate: 0,
        Total_ACT:0
      });
    } else if (currentfilter[1] && currentfilter[0] === '') {
      const key = findKeyByValue(storeNameList, currentfilter[1]);
      filterARList = Object.keys(ARateList?.storesAR || {}).reduce((acc, storeName) => {
        if (storeName === key) {
          acc = ARateList.storesAR?.[key]?.All;
        }
        return acc;
      }, {
        act: 0,
        actWithoutAcc: 0,
        actCount: 0,
        hup: 0,
        actARate: 0,
        hupARate: 0,
        Total_ACT:0
      });
    } else if (currentfilter[1] && currentfilter[0]) {
      const key = findKeyByValue(storeNameList, currentfilter[1]);
      filterARList = Object.keys(ARateList?.storesAR || {}).reduce((acc, storeName) => {
        if (storeName === key) {
          acc = ARateList.storesAR?.[key]?.[emailPrefix];
        }
        return acc;
      }, {
        act: 0,
        actWithoutAcc: 0,
        actCount: 0,
        hup: 0,
        actARate: 0,
        hupARate: 0,
        Total_ACT:0
      });
    }
  }

  return filterARList
};


export const ADMIN_ROLE = 'admin';
export const MANAGER_ROLE = 'manager';
export const EMPLYEE_ROLE = 'employee';
